import { Property } from '../models/RuleEngineConfig';
import { Rule } from '../models/Rule';
import {
  countryCodeToDisplayNameMap,
  extendedCountryToStates,
  CountryCode,
  CountryRegionType,
} from '@pdqdev/pdq-shared/dist/utils/Country-utils';
import { TimeFrame } from '../mapping/PropertyOperatorMapping';
import { currencyUnitsToCurrencySymbolMap } from '@pdqdev/pdq-shared/dist/utils/currency-utils';

export const formatRuleAsText = (rule: Rule): string => {
  if (!rule.property || !rule.operator || !rule.value) {
    return '';
  }

  let formattedValue = rule.value;

  if (rule.property === Property.country) {
    try {
      const parsedValue = JSON.parse(rule.value);
      if (typeof parsedValue === 'object' && !Array.isArray(parsedValue)) {
        const countryNames = Object.keys(parsedValue).map((countryCode) => {
          const countryName = countryCodeToDisplayNameMap[countryCode] || countryCode;
          const selectedStates = parsedValue[countryCode] || [];
          const totalStates = extendedCountryToStates[countryCode]?.length ?? 0;

          if (totalStates > 0 && selectedStates.length > 0) {
            const regionType = countryCode === CountryCode.CA ? CountryRegionType.PROVINCES : CountryRegionType.STATES;
            return `${countryName} (${selectedStates.length} of ${totalStates} ${regionType})`;
          }

          return countryName;
        });
        formattedValue = countryNames.join(', ');
      } else {
        formattedValue = rule.value;
      }
    } catch (e) {
      formattedValue = rule.value;
    }
  } else {
    try {
      const parsedValue = JSON.parse(rule.value);
      if (Array.isArray(parsedValue)) {
        formattedValue = parsedValue.join(', ');
      }
    } catch (e) {
      formattedValue = rule.value;
    }
  }

  let ruleText = `${rule.property} ${rule.operator} ${formattedValue}`;

  if (rule.property === Property.customerOrderCount) {
    if (rule.measuringUnit === TimeFrame.WITHIN_LAST_DAYS && rule.optionalValue) {
      ruleText += ` within the last ${rule.optionalValue} Calendar days`;
    } else {
      ruleText += ' all time';
    }
  }

  if (rule.property === Property.weight && rule.measuringUnit) {
    ruleText += ` ${rule.measuringUnit}`;
  }

  if (rule.property === Property.grossMargin) {
    if (rule.measuringUnit && currencyUnitsToCurrencySymbolMap[rule.measuringUnit]) {
      ruleText += `${currencyUnitsToCurrencySymbolMap[rule.measuringUnit]}`;
    } else {
      ruleText += '%';
    }
  }

  return ruleText;
};
